var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogosp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 65,
    viewBox: "0 0 57 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.104 34.723V21.2921C39.1393 21.2921 40.6569 20.1236 40.6569 17.7864C40.6569 15.6466 39.5035 14.5767 37.1816 14.5767C34.8444 14.5767 33.6759 16.0412 33.6759 18.9702V37.1892C33.6759 45.6119 26.8466 52.4412 18.4238 52.4412V20.5409C18.4238 17.2477 18.7577 14.5463 19.4179 12.4444C20.078 10.3425 21.2087 8.36965 22.8097 6.54851C24.6081 4.53008 26.8542 2.929 29.5479 1.76043C32.2417 0.59187 35.0265 0 37.9024 0C43.0927 0 47.4558 1.74526 50.9918 5.24336C54.5279 8.74146 56.2883 13.0743 56.2883 18.2341C56.2883 23.2499 54.7024 27.3247 51.5306 30.4434C48.632 33.3117 44.2612 34.7534 38.426 34.7534L36.104 34.723Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3734 12.2395C6.88238 12.2395 0 19.1219 0 27.613V64.9235C8.49106 64.9235 15.3734 58.0412 15.3734 49.5501V12.2395Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogosp);
export default __webpack_public_path__ + "static/media/logosp.088dcb8ddb5d8f09734afcd40c107eeb.svg";
export { ForwardRef as ReactComponent };